import type { Router } from 'expo-router';
import { queryStringParam } from '@/services/appleDeepLinkSurface';
import { toLocalDateKey } from '@/utils/dateKeys';

export const routeDateKeyParam = (value: unknown): string | undefined => {
  const raw = queryStringParam(value);
  if (!raw || !/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
    return undefined;
  }
  return raw;
};

export const isTodayFocusParam = (value: unknown): boolean =>
  queryStringParam(value) === 'today';

/** Day key from widget / App Intent deep links (`day=…` or `focus=today`). */
export const resolveRouteFocusedDateKey = (params: {
  day?: unknown;
  focus?: unknown;
}): string | undefined => {
  const dayKey = routeDateKeyParam(params.day);
  if (dayKey) return dayKey;
  if (isTodayFocusParam(params.focus)) {
    return toLocalDateKey(new Date());
  }
  return undefined;
};

export const isWidgetRouteFocusParam = (params: Record<string, unknown>): boolean =>
  Boolean(routeDateKeyParam(params.day) || isTodayFocusParam(params.focus));

/** Drop one-shot widget routing params so calendar day picks are not overridden. */
export const consumeWidgetRouteParams = (
  router: Pick<Router, 'setParams'>,
  opts: { keepTripId?: string; keepItemId?: string } = {},
): void => {
  router.setParams({
    tripId: opts.keepTripId,
    itemId: opts.keepItemId,
    day: undefined,
    focus: undefined,
    appIntent: undefined,
    appleSurface: undefined,
    from: undefined,
  });
};
